import { apiReadWithAuth } from '../../fetchUtils';

export const BEGIN_ASSIGNMENTS_FETCH = 'BEGIN_ASSIGNMENTS_FETCH'
export const FETCH_ASSIGNMENTS_SUCCESS = 'FETCH_ASSIGNMENTS_SUCCESS'
export const FETCH_ASSIGNMENTS_FAILURE = 'FETCH_ASSIGNMENTS_FAILURE'

function beginFetch() {
  return { type: BEGIN_ASSIGNMENTS_FETCH }
}

function fetchSuccess() {
  return { type: FETCH_ASSIGNMENTS_SUCCESS }
}

function fetchFailure(errorMessage) {
  return { type: FETCH_ASSIGNMENTS_FAILURE, errorMessage}
}

export function fetchAssignments(dispatch) {
  dispatch(beginFetch())
  const callbacks = {
    onSuccess:  ()=>dispatch(fetchSuccess()),
    onError:    error=>dispatch(fetchFailure(error))
  }
  dispatch(apiReadWithAuth('/assignments?include=section,course', callbacks))
}

